import $ from 'jquery'

const getCookie = (cname) => {
  const name = `${cname}=`
  const decodedCookie = decodeURIComponent(document.cookie)
  const ca = decodedCookie.split(';')

  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

const contactForm = () => {
  const $checkBox = $(".c-input-checkbox[type='checkbox']")
  const $submitButton = $('.c-box-button button')
  const $privacyErrorMsg = $('.c-box-button .wpcf7-not-valid-tip')

  $checkBox.on('change', () => {
    const ischecked = $checkBox.is(':checked')
    if (!ischecked) {
      $submitButton.addClass('is-disable')
    } else {
      $submitButton.removeClass('is-disable')
      $privacyErrorMsg.css('display', 'none')
    }
  })

  $(() => {
    const $form = $('.c-form')
    const ischecked = $checkBox.is(':checked')
    const checkVal = $checkBox.val()

    if (!$form.hasClass('is-confirm')) {
      if (!ischecked) {
        $checkBox.addClass('no-check')
        $submitButton.addClass('is-disable')
      } else {
        $checkBox.removeClass('is-checked')
        $submitButton.removeClass('is-disable')
      }

      const formCookie = getCookie('cf7msm_posted_data')

      if (formCookie !== '') {
        if (checkVal) {
          $checkBox.attr('checked', 'checked')
          $submitButton.removeClass('is-disable')
        } else {
          $checkBox.removeAttr('checked', 'checked')
          $submitButton.addClass('is-disable')
          $submitButton.preventDefault()
        }
      }
    }
  })
}

const privacyCheck = () => {
  const $formContact = $('.c-form')
  const $privacyErrorMsg = $('.c-box-button .wpcf7-not-valid-tip')
  const $submitButton = $('.c-box-button button')

  if ($submitButton) {
    $submitButton.on('click', (e) => {
      if (!$formContact.hasClass('is-confirm')) {
        if ($submitButton.hasClass('is-disable')) {
          e.preventDefault()
          $privacyErrorMsg.css('display', 'block')
        }
      }
    })
  }
}

const selectChosen = () => {
  const $this = $('.c-input-selectbox select')
  $this.on('change', () => {
    if ($this.val() !== '') {
      $this.addClass('selected')
    } else {
      $this.removeClass('selected')
    }
  })

  $(() => {
    if ($this.val() !== '') {
      $this.addClass('selected')
    }
  })
}

const initContact = () => {
  privacyCheck()
  contactForm()
  selectChosen()
}

export default initContact
